var _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWordcloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 600,
    fontFamily: "serif",
    textAnchor: "middle",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    fontSize: 75,
    transform: "translate(341,297) rotate(-6.456421428107859)",
    padding: "2px",
    fill: "#f2006d"
  }, "elbrus")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fontSize: 50,
    transform: "translate(412,346) rotate(5.60682613160866)",
    padding: "2px",
    fill: "#00b4f2"
  }, "fullstack")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    fontSize: 25,
    transform: "translate(186,359) rotate(-14.889393635478179)",
    padding: "2px",
    fill: "#f2e900"
  }, "javascript")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    fontSize: 25,
    transform: "translate(307,383) rotate(-16.267850013278338)",
    padding: "2px",
    fill: "#a300f2"
  }, "\u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    fontSize: 25,
    transform: "translate(267,246) rotate(-3.3436376265201595)",
    padding: "2px",
    fill: "#00f25c"
  }, "backend")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    fontSize: 25,
    transform: "translate(379,383) rotate(-13.8068182235385)",
    padding: "2px",
    fill: "#f21500"
  }, "express")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    fontSize: 25,
    transform: "translate(270,355) rotate(11.323716738534575)",
    padding: "2px",
    fill: "#0030f2"
  }, "react")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    fontSize: 25,
    transform: "translate(233,325) rotate(6.2376560306890205)",
    padding: "2px",
    fill: "#77f200"
  }, "coding")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    fontSize: 25,
    transform: "translate(242,185) rotate(14.244726686281709)",
    padding: "2px",
    fill: "#f200be"
  }, "bootcamp")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    fontSize: 25,
    transform: "translate(386,216) rotate(-9.99501591945835)",
    padding: "2px",
    fill: "#00f2df"
  }, "agile")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    fontSize: 25,
    transform: "translate(356,440) rotate(-14.372755305283276)",
    padding: "2px",
    fill: "#f29800"
  }, "stand")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    fontSize: 25,
    transform: "translate(203,299) rotate(-8.172544544090865)",
    padding: "2px",
    fill: "#5200f2"
  }, "up")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    fontSize: 25,
    transform: "translate(217,272) rotate(0.2702805035605671)",
    padding: "2px",
    fill: "#00f20b"
  }, "daily")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    fontSize: 25,
    transform: "translate(241,220) rotate(-0.23566386740191803)",
    padding: "2px",
    fill: "#f2003b"
  }, "typescript")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    fontSize: 25,
    transform: "translate(232,385) rotate(-18.451390449303453)",
    padding: "2px",
    fill: "#0081f2"
  }, "html")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    fontSize: 25,
    transform: "translate(353,414) rotate(-12.922409272356967)",
    padding: "2px",
    fill: "#c8f200"
  }, "css")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    fontSize: 25,
    transform: "translate(237,429) rotate(8.848722452588582)",
    padding: "2px",
    fill: "#d500f2"
  }, "datascience")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    fontSize: 25,
    transform: "translate(159,395) rotate(-14.448679511701856)",
    padding: "2px",
    fill: "#00f28e"
  }, "cookies")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    fontSize: 25,
    transform: "translate(433,151) rotate(-3.827986779614392)",
    padding: "2px",
    fill: "#f24700"
  }, "app")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    fontSize: 25,
    transform: "translate(175,252) rotate(-5.874852568233768)",
    padding: "2px",
    fill: "#0100f2"
  }, "eslint")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordcloud);
export default __webpack_public_path__ + "static/media/wordcloud.7c3455f4a3ef4f7d12dadd562bed0512.svg";
export { ForwardRef as ReactComponent };